/*
 * Rewords the notice Shopify gives when a shopper asks for more of an item
 * than there is in stock.
 *
 * The cart endpoints write that notice, not the theme, so it cannot be
 * changed in the locale files. In Japanese it reads as though the item's
 * listing were the reason ("出品状況により…"), which says nothing about stock.
 * This watches for the sentence wherever the theme prints it and swaps in one
 * that names the cause. Other languages' wording is left as Shopify sends it.
 */
(() => {
  const STOCK_NOTICE = /出品状況により、アイテム(\d+)点のみがカートに追加されました。?/;

  /** @param {string} text */
  const reword = (text) =>
    text.replace(STOCK_NOTICE, (_, count) => `在庫が${count}点のため、カートに入れられるのは${count}点までです。`);

  /** @param {Node} node */
  const fix = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const current = node.textContent || '';
      if (STOCK_NOTICE.test(current)) node.textContent = reword(current);
      return;
    }

    if (!(node instanceof Element) || !STOCK_NOTICE.test(node.textContent || '')) return;

    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) fix(walker.currentNode);
  };

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'characterData') fix(mutation.target);
      for (const added of mutation.addedNodes) fix(added);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
